import React from 'react';
import { observer, inject } from 'mobx-react';

import { SubBlockList, SubBlockListProps } from './SubBlockList';
import { EntryPage as EntryPageStore } from '@patient/ui/shared/store';

interface Props extends SubBlockListProps {}

interface StoreProps {
    entryPage: EntryPageStore;
}

@observer
class Component extends React.Component<Props & StoreProps> {
    public render(): React.ReactNode {
        const {
            entryPage: { rightContentMenu },
        } = this.props;

        const blockIndexes = rightContentMenu.subItemsKeys;

        return React.createElement(SubBlockList, {
            blockIndexes,
        });
    }
}

export const SubBlockListContainer = inject<Props, StoreProps>(EntryPageStore.Name)(Component);
